import React from "react"
import TopTitle from "@components/TopTitle"
import Wrapper from "@components/Wrapper"
import styles from "./SectionOne.module.scss"
import ArticleGraphic from "./SectionOne.png";


export default class SectionOne extends React.Component {

    render() {
        return (
            <section className="container-fluid bg-xl-light-gray">
                <div className="row ml-0 mr-0">
                    <Wrapper className={"w-100 text-left"} gap="outer">
                        <div className="row bg-white justify-content-center pt-10">
                            <div className={"col-auto col-lg-10 m-lg-2 " + styles.contactParent}>
                                <h3
                                className={
                                    styles.title +
                                    " proxima-nova--extra-bold text-secondary fs-30pt fs-lg-42pt pb-10"
                                }
                                >
                                    Central Control for Login and Access – In The Cloud!
                                </h3>
                                <div className={styles.contactRow + " row bg-white"}>
                                    <div className={ styles.topTextBody + " col-12"}>
                                        <img alt="EngineID MFA API" className={styles.tabletImage} src={ArticleGraphic} />
                                        <p>
                                            OpenID Connect is a wildly popular, standards-based protocol for handling authentication and authorization. It allows third-party systems and applications to trust an identity 
                                            authenticated from a centralized system. This means that one user can sign on to multiple applications with just one credential.
                                        </p>
                                        <p>
                                            Modern businesses of all sizes use OpenID Connect to authenticate their staff, contractors, partners and customers. In the past, setting up OpenID Connect required lots of 
                                            careful planning, expensive server setup on internal networks and of course constant maintenance. EngineID changes the game by having a ready-now OpenID Connect service in the 
                                            cloud available for you to start using immediately. No more patching, no more maintenance.
                                        </p>
                                        <p>
                                            OpenID Connect is becoming increasingly important when developing an Identity and Access Management strategy for your organization. In a landscape where applications are being 
                                            developed at a rapid pace, it is your job to ensure authentication and access to assets is managed in a controlled manner.
                                        </p>
                                        <p>
                                            Trying to maintain separate user databases for all of your applications is technically difficult. Additionally, having users remember different credentials for different systems 
                                            will reduce engagement across the organization.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Wrapper>
                </div>
            </section>
        );
    }
}